<template>
  <div>
    <van-list
      v-model:loading="oLoading"
      v-model:error="error"
      :finished="oFinished"
      finished-text="没有更多内容了~"
      error-text="请求失败，点击重新加载~"
      @load="onLoad"
    >
      <slot></slot>
    </van-list>
  </div>
</template>

<script>
  export default {
    emits: ['getPager'],
    props: {
      pager: {
        type: Object,
        default: {}
      },
      loading: {
        type: Boolean,
        default: false
      },
      finished: {
        type: Boolean,
        default: false
      },
      error: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        oPager: this.pager,
        oLoading: this.loading,
        oFinished: false
      }
    },
    mounted() {

    },

    methods: {
      onLoad() {
        const total = this.pager.total; //列表总数
        let listNum = 0;  //已加载的列表个数

        listNum = this.oPager.currentPage * this.oPager.pageSize
        console.log(listNum)
        console.log(total)
        if(this.oPager.currentPage === 0 || listNum < total) {
          this.oPager.currentPage += 1
          this.$emit('getPager', this.oPager)
        } else {
          this.oFinished = true
          this.oLoading = false
        }
      }
    },
    watch: {
      loading(newVal) {
        this.oLoading = newVal
      },
      finished(newVal) {
        this.oFinished = newVal
        console.log('watch-[LoadList]->finished', newVal)
      },
      oLoading(newVal) {
        this.$emit('update:loading', newVal)
      },
      oFinished(newVal) {
        this.$emit('update:finished', newVal)
      },
      pager(newVal) {
        this.oPager = newVal
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
